import { useEffect } from 'react';
import { IOrderNavigationSlice, orderNavigationSlice } from '../../store/order/orderNavigation/orderNavigationSlice';
import { useAppDispatch } from '../../store/store';

export const useSetOrderNavigationTab = (options: IOrderNavigationSlice) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(orderNavigationSlice.actions.setup(options));
  }, [dispatch, options]);
};
